import React from 'react'
import img1 from "./FCRA.png"
import img3 from "./CSR.png"
import { Link } from 'react-router-dom'
import home from './home.png'
import { TabTitle } from '../Utillity'

export default function BlogFCRARegistration() {
    TabTitle("medsys blog - FCRA registration");
    return (
        <>
            <h1 className="text-3xl text-center font-semibold text-mainColor my-4">FCRA Registration</h1>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>What is FCRA Registration?</h1>
                        <p className='tracking-wide'>The full form of FCRA is Foreign Contribution Regulation Act. When any charitable institution such as Trust, Society and Section 8 Company, wishes to receive funds or donations from foreign entity / resources, they shall register themselves under the Foreign Contribution Regulation Act, 2010.
                        </p>
                        <br />
                        <p className='tracking-wide'>Under Section 6 of Foreign Contribution Regulation Act, 2010, it is provided that any organization having a definite cultural / social / educational / religious / economic object shall accept foreign contribution / donations only after getting FCRA Registration.

                        </p>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Pre-requisites of FCRA Registration Online</h1>
                        <br />
                        <div className='tracking-wide'><div className="flex gap-2"><div>⦁ </div><p> The Organization needs to be a duly registered organization for charitable purposes.</p> <br /></div>
                            <div className="flex gap-2"><div>⦁ </div><p> The Non-Profit Organization should have active existence for the last 3 years.</p> <br /> </div>
                            <div className="flex gap-2"><div>⦁ </div><p> The Organization must be registered under the NGO Darpan Registration.</p> <br /></div>
                            <div className="flex gap-2"><div>⦁ </div><p> The organization must agree to receive foreign contributions only through one specific bank account.</p></div>
                        </div>

                    </div>
                </div>
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>The Objective of Foreign Contribution Regulation Act, 2010</h1>
                        <br />
                        <p className='tracking-wide'>The Foreign Contribution Regulation Act, 2010 was enacted with a view to: <br />
                            <div className="flex gap-2"><div>⦁ </div><p>Regulate the acceptance and utilization of foreign contributions or foreign hospitality by certain individual associations or companies . </p></div>
                            <div className="flex gap-2"><div>⦁ </div><p>Prohibit the acceptance and utilization of foreign hospitality or foreign contribution for any activities unfavourable to national interest and for matters related to therewith or incidental thereto..</p></div>
                        </p>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Benefits of FCRA Registration in India</h1><br />
                        <div className='tracking-wide'>
                            <div className="flex gap-2"><div>⦁ </div><p> An entity registered under the system of FCRA Registration would hold a good reputation in the society.</p></div>
                            <div className="flex gap-2"><div>⦁ </div><p> FCRA Registration helps those organizations which work for the benefit and better of the public and are involved in the social work.</p></div>
                            <div className="flex gap-2"><div>⦁ </div><p> The FCRA Registrations helps the organization to receive lawfully the foreign contribution and government aids.</p></div>
                            <div className="flex gap-2"><div>⦁ </div><p> The applicant may get the benefit of having full government support as FCRA Registration is a Government Registration and is prescribed by the regulatory authority.</p></div>
                            <div className="flex gap-2"><div>⦁ </div><p> An entity registered under FCRA can receive donations from foreign bodies as well as continuous support and investment from entities.</p></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>
                        <h1 className='text-3xl font-bold'>The types of FCRA Registration Online <br /> Proper FCRA Registration (FCRA Registration in normal course)
                        </h1>
                        <div className='tracking-wide'><div className="flex gap-3"><div>⦁ </div><p> For getting Proper FCRA Registration, the applicant must be registered and operating as an NGO for a minimum period of 5 years.</p></div>
                            <div className="flex gap-3"><div>⦁ </div><p> The Non-Profit Organization must have spent minimum 10 Lakh rupees in the last 3 years for furtherance of its main objects.</p></div>
                            <div className="flex gap-3"><div>⦁ </div><p> The applicant is also required to submit the financial statements for last 3 years. Further, these financial statements must be audited by a qualified practicing Chartered Accountant.</p></div>
                            <div className="flex gap-3"><div>⦁ </div><p> For FCRA Registration, Form FC-3A needs to be filed.</p></div>

                        </div>
                    </div>
                    <div>
                        <h1 className='text-3xl font-bold'>Validity for FCRA Registration in normal course
                        </h1>
                        <div className='tracking-wide'><div className="flex gap-3"><div>⦁ </div><p> The FCRA Registration in normal course is valid for a period of 5 years from the date of approval.</p></div>
                            <div className="flex gap-3"><div>⦁ </div><p> After the expiry of this period of 5 years, it is required to be renewed for receiving any further foreign contributions.</p></div>

                        </div>
                    </div>
                </div>
                <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div>
            </div>
            <div className="m-auto content max-width-1 my-2">
                <div className="content-left flex flex-col">
                    <div className='mb-6'>

                        <div className="w-9/12 m-auto">
                            <div className='flex items-center gap-2'>
                                <h1 className="text-3xl font-bold my-2" >Process of FCRA Registration
                                </h1>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Login to FCRA Portal</p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Click on the
                                    Form FC – 3A (Application for FCRA Registration) or
                                    Form FC – 3B (Application for FCRA Prior Permission), as the case may be.
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">The page will appear Apply Online Option. Select the “Apply Online” option and create a username and password by clicking on “Sign Up”.
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Select FC-3 menu and start the registration process.

                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">Follow the steps, upload the documents in PDF and enter the details of the bank.
                                </p>
                            </div>
                            <div className='flex items-center gap-2'>
                                <p>⦁ </p>
                                <p style={{ fontSize: "19px" }} className="my-2">The final step is to pay the online fees.
                                </p>
                            </div>
                        </div>

                    </div>

                </div>
                {/* <div className="content-right">
                    <img style={{ width: "355px", maxWidth: "355px" }} src={home} alt="iBlog" />
                </div> */}
            </div>

            {/* =============================================================== */}
            <div className="max-width-1 m-auto"><hr /></div>
            <div className="home-articles max-width-1 m-auto font2">
                <h2 className="text-3xl mb-6 text-center text-mainColor font-bold" style={{ borderBottom: "1px solid #e8dada" }}>People Read This Also</h2>
                <div className="row">


                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img src={img3} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-mainColor text-2xl'>What is form CSR 1 Registration?</h3>

                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/blog-post-1">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>
                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img style={{ width: "393px" }} src={img1} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-2xl text-mainColor'>What is FCRA Registration?</h3>
                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/FCRA-registration">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>
                    <div className="home-article more-post">
                        <div className="home-article-img">
                            <img src={img3} alt="article" />
                        </div>
                        <div className="home-article-content font1 flex flex-col">
                            <h3 className='text-mainColor text-2xl'>What is form CSR 1 Registration?</h3>

                            <div>Bhushan shirude</div>
                            <span>07 January | 6 min read</span>
                            <Link to="/blog-post-1">
                                <button className='w-32 h-9 mt-6 rounded hover:bg-rose-700 bg-mainColor text-white'>Read More</button>
                            </Link>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
